interface FilterChip {
  id: string;
  label: string;
  value: string;
}

interface FilterChipsProps {
  filters: FilterChip[];
  activeFilters: string[];
  onToggle: (value: string) => void;
  onClear?: () => void;
}

export default function FilterChips({ filters, activeFilters, onToggle, onClear }: FilterChipsProps) {
  const hasActiveFilters = activeFilters.length > 0 && activeFilters[0] !== "";

  return (
    <div className="flex flex-wrap items-center gap-2">
      {filters.map((filter) => {
        const isActive = activeFilters.includes(filter.value) || (filter.value === "" && activeFilters.length === 0);
        return (
          <button
            key={filter.id}
            onClick={() => onToggle(filter.value)}
            className={`px-4 py-1.5 rounded-full text-sm font-semibold transition-all duration-200 border ${isActive
                ? 'bg-blue-600 text-white border-blue-600 shadow-sm'
                : 'bg-white text-gray-600 border-gray-200 hover:border-gray-300 hover:bg-gray-50'
              }`}
          >
            {filter.label}
          </button>
        );
      })}

      {hasActiveFilters && onClear && (
        <button
          onClick={onClear}
          className="text-sm font-medium text-gray-500 hover:text-blue-600 px-2 py-1 transition-colors flex items-center gap-1"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
          Clear All
        </button>
      )}
    </div>
  );
}



